import {
  Button,
  Text,
  ModalV2,
  ModalBody,
  Flex,
  IconInCircle,
  ColorsV2,
  useThemeColors,
  spaces,
} from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { useGlobalUI } from '@/components/GlobalUIProvider';

export const InternationalRequestSuccessModal = () => {
  const { t } = useTranslation('pages');
  const { closeModal } = useGlobalUI();
  const [iconColor, backgroundColor] = useThemeColors([
    ColorsV2.WHITE,
    ColorsV2.SUCCESS,
  ]);

  return (
    <ModalV2
      ariaLabelledby="international-request-success-modal"
      hide={() => {}}
      minWidth="65rem"
      visible
      borderRadius="12px">
      <ModalBody p={spaces.space_5xl}>
        <Flex vertical width="100%" hAlignContent="center" rowGap="0">
          <IconInCircle
            color={iconColor}
            icon="check"
            iconSize="large"
            size="6rem"
            backgroundColor={backgroundColor}
          />
          <Text textAlign="center" variant="heading-2" mt={spaces.space_xl}>
            {t('internationalOrderRequest.successModal.title')}
          </Text>
          <Text textAlign="center" variant="body" mt={spaces.space_xs}>
            {t('internationalOrderRequest.successModal.message')}
          </Text>
          <Button
            id="go-to-hardware-store"
            onClick={closeModal}
            intent="primary"
            mt={spaces.space_xl}>
            {t('internationalOrderRequest.successModal.buttonText')}
          </Button>
        </Flex>
      </ModalBody>
    </ModalV2>
  );
};
